import { UserRoleName } from 'models';
import noAvailableImage from '../../../assets/images/no-image-available.jpg';

export const getUniqueImages = (productSkus) => {
    const allImagesObjects = [];
    productSkus.map(sku => sku.images.map(img => (allImagesObjects.push(img))
    ));
    return allImagesObjects.filter((value, index, self) => {
      return (
        self.findIndex((v) => v.url === value.url) === index
      );
    });
  };

  export const noImgObject = {
  id: 999999,
  contentType: 'image/jpeg',
  url: noAvailableImage,
  label: '',
  mainImage: false,
  originalWidth: 828,
  originalHeight: 1078,
  portraitWidth: 0.9869,
  portraitX: -0.5519,
  portraitY: -5.7081,
  squareWidth: 1,
  squareX: 0,
  squareY: -0.2653,
  portrait: false,
  square: false
};

export const restrictUserRolesToAccessStore = [UserRoleName.VIEWER]